/* eslint-disable */
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import commonObj from "../commonObj";
class util {

    checkRightAccess = (key) => {
        if (!key) {
            return commonObj.userType === 'superAdmin';
        }
        if (typeof key === 'string') {
            return commonObj.userType === 'superAdmin' || commonObj?.adminRights?.includes(key);
        }
    }

    setUserData = (data) => {
        window.localStorage.clear();
        window.localStorage.setItem('authorization', data.token);
        window.localStorage.setItem('type', data.type);
    }
    getUserData = ($key) => {
        if ($key) {
            return JSON.parse(window.localStorage['user'])[$key];
        } else {
            return JSON.parse(window.localStorage['user']);
        }
    }
    setUserType = (data = '') => {
        window.localStorage.setItem('type', data);
    }
    userType = () => window.localStorage['type']
    getToken = () => {
        return window.localStorage['authorization'] || '';
    }
    isLogged = () => {
        if (typeof window.localStorage['authorization'] !== "undefined" && window.localStorage['authorization'] !== '') {
            return true;
        }
        return false;
    }
    logout = (e) => {
        if (e) e.preventDefault();
        window.localStorage.clear();
        window.location.reload();
    }
    setTheme($theme = 'light') {
        window.localStorage.setItem('theme', $theme);
        return $theme;
    }
    getTheme() {
        return window.localStorage?.theme;
    }
    removeSpecialChars(key) {
        return key?.trim().toLowerCase()?.replace(/[^a-z0-9 _-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
    }
    handleInteger($str, $len = 10) {
        let num = $str?.replace(/[^0-9]/g, '');
        return $len ? num?.substring(0, $len) : num;
    }
    handleFloat(value, maxValue) {
        value = value.replace(/[^0-9.]/g, '')
        let newValue = value.replace(/[\.\%]/g, function (match, offset, all) {
            return match === "." ? (all.indexOf(".") === offset ? '.' : '') : '';
        })
        if (maxValue) {
            if (newValue * 1 > maxValue * 1) {
                newValue = maxValue
            }
        }
        return newValue
    }
    toBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }
    queryStringToJSON(qs) {
        qs = qs || window.location.search.slice(1);
        if (qs.charAt(0) === '?') {
            qs = qs.slice(1);
        }

        var pairs = qs.split('&');
        var result = {};
        pairs.forEach(function (p) {
            var pair = p.split('=');
            var key = pair[0];
            var value = decodeURIComponent(pair[1] || '');
            if (result[key]) {
                if (Object.prototype.toString.call(result[key]) === '[object Array]') {
                    result[key].push(value);
                } else {
                    result[key] = [result[key], value];
                }
            } else {
                result[key] = value;
            }
        });

        return JSON.parse(JSON.stringify(result));
    };
    getFileFormat(data) {
        if (!Array.isArray(data)) {
            if (typeof data === 'string') {
                return [{
                    uid: data.split('/').pop(),
                    name: data.split('/').pop(),
                    url: data
                }];
            } else if(data) {
                return [{
                    uid: data.uid || data.id,
                    name: data.url.split('/').pop(),
                    url: data.url,
                    ...data
                }];
            }else{
                return []
            }
        } else {
            return data?.map(v => {
                if (typeof v === 'string') {
                    return {
                        uid: v.split('/').pop(),
                        name: v.split('/').pop(),
                        url: v
                    };
                } else {
                    return {
                        uid: v.uid || v.id,
                        name: v.url.split('/').pop(),
                        url: v.url,
                        ...v
                    };
                }
            })
        }
    }
    getTimeInSec(timeString) {
        timeString = timeString.trim().replace(/^(.*?)([AaPp][mM])?$/, "$1");
        const [hours, minutes] = timeString.split(":");
        let hoursInSec = parseInt(hours, 10) * 3600;
        const minutesInSec = parseInt(minutes, 10) * 60;

        if (hours === "12" && (timeString.endsWith("PM") || timeString.endsWith("pm"))) {
            hoursInSec += 12 * 3600;
        }
        return (hoursInSec + minutesInSec) || 0;
    }
    getTimeString(seconds, includeAMPM = false) {
        if (seconds < 0) {
            seconds = Math.abs(seconds);
        }
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);

        const formattedHours = hours ? hours.toString().padStart(2, '0') : '00';
        const formattedMinutes = minutes ? minutes.toString().padStart(2, '0') : '00';
        let timeString = `${formattedHours}:${formattedMinutes}`;
        if (includeAMPM) {
            const isPM = hours >= 12;
            const twelveHourHours = (hours % 12) || 12;
            timeString = `${twelveHourHours}:${formattedMinutes} ${isPM ? "PM" : "AM"}`;
        }
        return timeString;
    }
    getTableHeight() {
        return (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 1000) - 312;
    }
    amountFormat(amount = 0, options = {}) {
        const { formatName = 'en-IN', minimumFractionDigits = 2, maximumFractionDigits = 2 } = options
        return isFinite(amount) && Number(amount).toLocaleString(formatName, { minimumFractionDigits, maximumFractionDigits })
    }
    isValidMongooseId(id) {
        return /^[a-fA-F0-9]{24}$/.test(id);
    }

    handleTableSortingData = (sorter, setSort, curr_sort, refetch, qData) => {
        const updateSortAndRefetch = (newSort) => {
            setSort(newSort);
            if (typeof refetch === 'function') {
                refetch({ ...qData, sort: JSON.stringify(newSort) });
            }
        };
        // Multi-sort mode (array)
        if (Array.isArray(sorter) && sorter.length > 0) {
            const sortKeys = sorter
                .filter(item => item.order)
                .map(item => ({
                    column: item.field,
                    desc: item.order === 'ascend' ? 0 : 1,
                }));
            return updateSortAndRefetch(sortKeys);
        }
        // Single-sort mode (object)
        const { order, field } = sorter || {};
        if (!field) return;

        const newSortItem = {
            column: field,
            desc: order === 'ascend' ? 0 : 1,
        };

        if (order) {
            updateSortAndRefetch([newSortItem]);
        } else {
            // Sort removed for this column
            const filtered = curr_sort.filter(x => x.column !== field);
            return updateSortAndRefetch(filtered);
        }
    };



    cn(...args) {
        return twMerge(clsx(args));
    };

    renderTableText = (value, className) => value ? <span className={this.cn(className)}>{value}</span> : <span>NA</span>
}


export default new util();